import React from 'react';
import { Box, Group, Text } from '@mantine/core';
import { IconMapPin, IconClock } from '@tabler/icons-react';
import { isInRecentSearches } from '../../../../utils/searchHistory';
import { PlaceTypeBadge } from './PlaceTypeBadge';
import type { SearchResultItemProps } from '../types';
import styles from '../AddressSearchBar.module.css';

export const SearchResultItem = React.memo<SearchResultItemProps>(({
  result,
  index,
  isSelected,
  onSelect,
  isRecent = false,
}) => {
  const handleClick = () => {
    onSelect(result);
  };

  const shouldShowClockIcon = isRecent || isInRecentSearches(result.display_name);

  return (
    <Box
      id={`address-option-${index}`}
      className={`${styles.resultItem} ${isSelected ? styles.selected : ''}`}
      onClick={handleClick}
      role="option"
      aria-selected={isSelected}
    >
      <Group gap="sm" wrap="nowrap" justify="space-between" className={styles.placeNameGroup}>
        <Group gap="sm" wrap="nowrap" className={styles.flexContainer}>
          {shouldShowClockIcon ? (
            <IconClock size={16} className={styles.clockIcon} />
          ) : (
            <IconMapPin size={16} className={styles.locationIcon} />
          )}
          <Box className={styles.textContainer}>
            <Text size="sm" fw={500} lineClamp={1} className={styles.textTruncate}>
              {result.display_name.split(',')[0]}
            </Text>
            <Text size="xs" c="dimmed" lineClamp={1}>
              {result.display_name}
            </Text>
          </Box>
        </Group>
        <PlaceTypeBadge type={result.type} />
      </Group>
    </Box>
  );
});